import Dropdown from "../../../components/dropdown";
import React, { useEffect, useState } from "react";
import useProducers from "../../../../hooks/producers/useProducers";
import useChildProducers from "../../../../hooks/producers/useChildProducers";
import useSeasons from "../../../../hooks/seasons/useSeasons";
import useSpecies from "../../../../hooks/species/useSpecies";
import useVarieties from "../../../../hooks/varieties/useVarieties";
import { decryptText, encryptText } from "../../../../services/utilservices";

interface IFilterSelect {
  column: string;
  onProducerChange: (id: any) => void;
  onParentProducerChange: (id: any) => void;
  onSeasonChange: (id: any) => void;
  onSpeciesChange: (id: any) => void;
  onVarietyChange: (id: any) => void;
}

const Filtros = ({ column, onProducerChange, onParentProducerChange, onSeasonChange, onSpeciesChange, onVarietyChange }: IFilterSelect) => {

  const [selectedProducerId, setSelectedProducerId] = useState<any>(
    JSON.parse(decryptText(sessionStorage.getItem("filters") || "") || "{}").producerId || null
  );
  const [selectedParentProducerId, setSelectedParentProducerId] = useState<any>(
    JSON.parse(decryptText(sessionStorage.getItem("filters") || "") || "{}").parentProducerId || null
  );
  const [selectedSeasonId, setSelectedSeasonId] = useState<any>(
    JSON.parse(decryptText(sessionStorage.getItem("filters") || "") || "{}").seasonId || null
  );
  const [selectedSpeciesId, setSelectedSpeciesId] = useState<any>(
    JSON.parse(decryptText(sessionStorage.getItem("filters") || "") || "{}").speciesId || null
  );
  const [selectedVarietyId, setSelectedVarietyId] = useState<any>(
    JSON.parse(decryptText(sessionStorage.getItem("filters") || "") || "{}").varietyId || null
  );

  const [parentProducerSearch, setParentProducerSearch] = useState(decryptText(sessionStorage.getItem("parentProducerSearch") || ""));
  const [producerSearch, setProducerSearch] = useState(decryptText(sessionStorage.getItem("producerSearch") || ""));
  const [seasonSearch, setSeasonSearch] = useState(decryptText(sessionStorage.getItem("seasonSearch") || ""));
  const [speciesSearch, setSpeciesSearch] = useState(decryptText(sessionStorage.getItem("speciesSearch") || ""));
  const [varietySearch, setVarietySearch] = useState(decryptText(sessionStorage.getItem("varietySearch") || ""));

  const getLastAvailableSeason = (seasonArray: any[]) => {
    if (seasonArray && seasonArray.length > 0) {
      const availableSeasons = seasonArray.filter((season: any) => season.nombre !== "2023-2024");
      if (availableSeasons.length > 0) {
        return availableSeasons[availableSeasons.length - 1].id;
      }
    }
    return 6; 
  };

  interface Especie {
    especieId: string;
    variedades: string[];
  }

  const [reset, setReset] = useState(false);
  const [isLoadingRelations, setIsLoadingRelations] = useState(false);

  const [relations, setRelations] = useState<any>({
    temporadas: [],
    especies: []
  });

  const [inputValue, setInputValue] = useState("");
  const [selectId, setSelectId] = useState(null);
  const { producers } = useProducers(1, 10, column, parentProducerSearch, selectedParentProducerId);
  const { children } = useChildProducers(1, 10, column, producerSearch, selectId);
  const { seasons } = useSeasons(1, 10, column, seasonSearch);
  const { species } = useSpecies(1, 10, column, speciesSearch);
  const { varieties } = useVarieties(1, 10, column, varietySearch);
  interface FilterByInterface {
    pageNumber: number;
    parentProducerId?: number | null;
    seasonId?: number | null;
    speciesId?: number | null;
    varietyId?: number | null;
    producerId?: number | null;
  }
  useEffect(() => {
    onProducerChange(selectedProducerId);
    onParentProducerChange(selectedParentProducerId);
    onSeasonChange(selectedSeasonId);
    onSpeciesChange(selectedSpeciesId);
    onVarietyChange(selectedVarietyId);
  }, []);

  useEffect(() => {
    sessionStorage.setItem(
      "filters",
      encryptText(JSON.stringify({
        producerId: selectedProducerId,
        parentProducerId: selectedParentProducerId,
        seasonId: selectedSeasonId,
        speciesId: selectedSpeciesId,
        varietyId: selectedVarietyId,
      }))
    );
  }, [selectedProducerId, selectedParentProducerId, selectedSeasonId, selectedSpeciesId, selectedVarietyId]);

  const handleInputChange = (dropdownType: string, value: string) => {
    setInputValue(value);
    switch (dropdownType) {
      case "producerSearch":
        setProducerSearch(value);
        sessionStorage.setItem("producerSearch", encryptText(value));
        break;
      case "parentProducerSearch":
        setParentProducerSearch(value);
        sessionStorage.setItem("parentProducerSearch", encryptText(value));
        break;
      case "seasonSearch":
        setSeasonSearch(value);
        sessionStorage.setItem("seasonSearch", encryptText(value));
        break;
      case "speciesSearch":
        setSpeciesSearch(value);
        sessionStorage.setItem("speciesSearch", encryptText(value));
        break;
      case "varietySearch":
        setVarietySearch(value);
        sessionStorage.setItem("varietySearch", encryptText(value));
        break;
      default:
        break;
    }
  };

  const handleSelectChangeRelation = async () => {
    const savedFilters = JSON.parse(decryptText(sessionStorage.getItem('filters') || '{}'));

    if (selectedSpeciesId == savedFilters.speciesId && selectedProducerId == savedFilters.producerId && selectedParentProducerId == savedFilters.parentProducerId && selectedSeasonId == savedFilters.seasonId && selectedVarietyId == savedFilters.varietyId) {
      await fetchEspeciesandVariety();
    }

  }
  const [userSelectedSpecies, setUserSelectedSpecies] = useState(false);

  const handleSelectChange = async (parentId: any, isParent: boolean = false) => {
    setSelectId(parentId);
  
    if (isParent) {
      if (selectedProducerId != null) {
        const ProducerId = childrenNameCodesArray.find((e: any) => e.id == selectedProducerId);
  
        if (ProducerId != null && ProducerId.productorPadreId != parentId) {
          sessionStorage.setItem(
            "filters",
            encryptText(
              JSON.stringify({
                producerId: null,
                parentProducerId: selectedParentProducerId,
                seasonId: selectedSeasonId,
                speciesId: selectedSpeciesId,
                varietyId: selectedVarietyId,
              })
            )
          );
  
          sessionStorage.setItem("producerSearch", "");
          setProducerSearch("");
          setSelectedProducerId(null);
          onProducerChange(null);
        }
      }
  
      sessionStorage.removeItem("producer");
      setSpeciesSearch(""); 
      setUserSelectedSpecies(false);
      if (parentId !== selectedParentProducerId) {
        localStorage.removeItem("userSelectedSpecies");
        localStorage.removeItem("lastSelectedSpecies");
      }
      await updateSpeciesDefault();
    }
    setReset(false);
  };

  const updateSpeciesDefault = async () => {
    if (isLoadingRelations) {
      setTimeout(() => updateSpeciesDefault(), 100);
      return;
    }
    
    if (!relations.especies || relations.especies.length === 0) {
      return;
    }
    
    const speciesExists = relations.especies.some(
      (especie: any) => especie.especieId === selectedSpeciesId
    );
  
    const userSelectedSpecies = localStorage.getItem("userSelectedSpecies") === "true";
    const lastSelectedSpecies = localStorage.getItem("lastSelectedSpecies");
    
    if (!userSelectedSpecies || !speciesExists) {
      if (lastSelectedSpecies) {
        const lastSpeciesExists = relations.especies.some(
          (especie: any) => especie.especieId === Number(lastSelectedSpecies)
        );
        
        if (lastSpeciesExists) {
          setSelectedSpeciesId(Number(lastSelectedSpecies));
          onSpeciesChange(Number(lastSelectedSpecies));
          return;
        }
      }

      const cherries = relations.especies.find((especie: any) => especie.especieId === 3);
      let defaultSpecies = null;
      if (cherries) {
        defaultSpecies = cherries;
      } else if (relations.especies.length > 0) {
        const sorted = [...relations.especies].sort((a, b) => Number(a.especieId) - Number(b.especieId));
        defaultSpecies = sorted[0];
      }
      if (defaultSpecies) {
        setSelectedSpeciesId(defaultSpecies.especieId);
        onSpeciesChange(defaultSpecies.especieId);
        sessionStorage.setItem("autoSelectedSpecies", "true");
        localStorage.removeItem("userSelectedSpecies");
      }
    }
  };
  
  
  
  
  useEffect(() => {
    const updatedFilters = encryptText(
      JSON.stringify({
        producerId: selectedProducerId,
        parentProducerId: selectedParentProducerId,
        seasonId: selectedSeasonId,
        speciesId: selectedSpeciesId,
        varietyId: selectedVarietyId,
      })
    );
    sessionStorage.setItem("filters", updatedFilters);
  
    onProducerChange(selectedProducerId);
    onParentProducerChange(selectedParentProducerId);
    onSeasonChange(selectedSeasonId);
    onSpeciesChange(selectedSpeciesId);
    onVarietyChange(selectedVarietyId);
  }, [selectedProducerId, selectedParentProducerId, selectedSeasonId, selectedSpeciesId, selectedVarietyId]);
  

  const fetchEspeciesandVariety = async () => {
    if (isLoadingRelations) {
      return;
    }
    
    setIsLoadingRelations(true);
    
    const token = JSON.parse(decryptText(sessionStorage.getItem('data') || '{}')).token || null;
    const baseUrlenv = process.env.REACT_APP_API_URL;

    //const url = `${baseUrlenv}Productor`;
    let url = `${baseUrlenv}Miscelaneo/Relaciones?${selectedParentProducerId != null ? "ProductorPadreId=" + selectedParentProducerId : ''}${selectedProducerId != null ? '&ProductorId=' + selectedProducerId : ''}${selectedSeasonId != null ? '&TemporadaId=' + selectedSeasonId : ''}`;

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error("Error en la llamada al API");
      }

      const data = await response.json();
      setRelations(data);
      return data;
    } catch (error) {
      console.error("Error:", error);
      throw error;
    } finally {
      setIsLoadingRelations(false);
    }
  };

  useEffect(() => {
    const localProfile = JSON.parse(decryptText(sessionStorage.getItem('data') || '{}')).perfilDescripcion || null;
    if (localProfile && (localProfile === 'Administrador' || localProfile === 'Estandar') || localProfile === 'Productor') {
      let filters = decryptText(sessionStorage.getItem('filters') || "");
      if (filters) {
   
        const parsedFilters: FilterByInterface = JSON.parse(filters);

        const seasonId = parsedFilters.seasonId != null ? parsedFilters.seasonId : 5;  // Si 'seasonId' es null, asignamos 5
        const speciesId = parsedFilters.speciesId != null ? parsedFilters.speciesId : 3; // Si 'speciesId' es null, asignamos 3
        const parentProducerId = parsedFilters.parentProducerId != null ? parsedFilters.parentProducerId : null; // Si 'parentProducerId' es null, asignamos 2615
        const producerId = parsedFilters.producerId != null ? parsedFilters.producerId : null; // Si 'parentProducerId' es null, asignamos 2615
        let varietyId: number | null = parsedFilters.varietyId != null ? parsedFilters.varietyId : null;  // Si 'varietyId' es null, asignamos 1

        setSelectedSeasonId(seasonId);
        setSelectedSpeciesId(speciesId);
        if(localProfile != 'Productor'){
          setSelectedParentProducerId(parentProducerId);
        }
   
        
        if (varietyId == 1) {
          varietyId = null;
        }
       // console.log("Codigo hijo: ", producerId);

        setSelectedVarietyId(varietyId);
        setSelectedProducerId(producerId);

      } else {
        setSelectedSeasonId(5);
        setSelectedSpeciesId(3);
       
        //setSelectedParentProducerId(2615);
        //setSelectedVarietyId(4)

      }
    }

  }, []);


  useEffect(() => {
    if (selectedParentProducerId || selectedProducerId || selectedSeasonId) {
      fetchEspeciesandVariety();
    }
  }, [selectedParentProducerId, selectedProducerId, selectedSeasonId])

  useEffect(() => {
    if (relations.especies && relations.especies.length > 0) {
      updateSpeciesDefault();
    }
  }, [relations])
  
  
  const producersData: any = producers;
  const childrenData: any = children;
  const seasonsData: any = seasons;
  const speciesData: any = species;
  const varietiesData: any = varieties;

  let fatherProducerCodesArray: any = [];
  let childrenNameCodesArray: any = [];
  let seasonArray: any = [];
  let speciesArray: any = [];
  let varietiesArray: any = [{ id: null, nombre: 'Todas' }];

  if (producersData.lista) fatherProducerCodesArray = producersData.lista;
  if (childrenData.lista) {
    let childrenArray: any = [{ id: null, nombre: 'Todas' }];

    let array = childrenData.lista;

    childrenNameCodesArray.push(...childrenArray);
    childrenNameCodesArray.push(...array);
  }
  if (seasonsData) seasonArray = seasonsData;
  if (speciesData) speciesArray = speciesData;
  if (varietiesData) varietiesArray.push(...varietiesData);

  useEffect(() => {
    const savedFilters = sessionStorage.getItem("filters");
    const autoSelectedSpecies = sessionStorage.getItem("autoSelectedSpecies");
    const userSelectedSpecies = localStorage.getItem("userSelectedSpecies");
    const lastSelectedSpecies = localStorage.getItem("lastSelectedSpecies");
    
    if (savedFilters) {
      const parsedFilters = JSON.parse(decryptText(savedFilters) || "{}");
  
      setSelectedProducerId(parsedFilters.producerId || null);
      setSelectedParentProducerId(parsedFilters.parentProducerId || null);
      setSelectedSeasonId(parsedFilters.seasonId || getLastAvailableSeason(seasonArray)); 
      
      if (lastSelectedSpecies && userSelectedSpecies === "true") {
        setSelectedSpeciesId(Number(lastSelectedSpecies));
      } else {
        setSelectedSpeciesId(parsedFilters.speciesId || 3);
      }
      
      setSelectedVarietyId(parsedFilters.varietyId || null);
      
      if (userSelectedSpecies === "true") {
        setUserSelectedSpecies(true);
      }
    } else {
      setSelectedSeasonId(getLastAvailableSeason(seasonArray));
      setSelectedSpeciesId(3);
    }
  }, [seasonArray]);

  const handleReset = () => {
    const productoresIds = JSON.parse(decryptText(sessionStorage.getItem("prod") || "") || "[]");
    const localProfile = JSON.parse(decryptText(sessionStorage.getItem("data")!)).perfilDescripcion;
    setParentProducerSearch("");
    setProducerSearch("");
    setSeasonSearch("");
    setSpeciesSearch("");
    setVarietySearch("");
    
    sessionStorage.removeItem("autoSelectedSpecies");
    localStorage.removeItem("userSelectedSpecies");
    localStorage.removeItem("lastSelectedSpecies");
    
    if (productoresIds.length > 0) {
      if(localProfile!="Productor"){
        const firstProducerId = fatherProducerCodesArray[0]; 
        setSelectedParentProducerId(firstProducerId);
      }
      else{
        const firstProducerId = productoresIds[0]; 
        setSelectedParentProducerId(firstProducerId);
        onParentProducerChange(null);
        setSelectedProducerId(null);
        onProducerChange(null);
        setSelectedVarietyId(null);
        onVarietyChange(null);
    
        sessionStorage.removeItem("producer");
      }
    }
    else {
      setReset(true);
      setInputValue("");
      setSelectId(null);
      setSelectedParentProducerId(null);
      setSelectedProducerId(null);
      
      const lastSeasonId = getLastAvailableSeason(seasonArray);
      setSelectedSeasonId(lastSeasonId);
      setSelectedSpeciesId(3);
      setSelectedVarietyId(null);
      onParentProducerChange(null);
      onProducerChange(null);
      onSeasonChange(null);
      onSpeciesChange(null);
      onVarietyChange(null);
      setSelectedProducerId(null);
      setSelectedParentProducerId(null);
      sessionStorage.removeItem("parentProducer");
      sessionStorage.removeItem("producer");
      sessionStorage.removeItem("autoSelectedSpecies");

      sessionStorage.setItem(
        "filters",
        encryptText(JSON.stringify({
          producerId: selectedProducerId,
          parentProducerId: selectedParentProducerId,
          seasonId: lastSeasonId,
          speciesId: 3,
          varietyId: selectedVarietyId,
        }))
      );
    }
  };
  const filteredSeasonArray = seasonArray.filter((season: any) =>
    season.nombre !== "2023-2024" && season.nombre.toLowerCase().includes(seasonSearch.toLowerCase())
  );
  const filteredSpeciesArray = speciesArray.filter((species: any) =>
    species.nombre.toLowerCase().includes(speciesSearch.toLowerCase())
  );
  const filteredVarietiesArray = varietiesArray.filter((variety: any) =>
    variety.nombre.toLowerCase().includes(varietySearch.toLowerCase())
  );
  const filteredChildrenNameCodesArray = childrenNameCodesArray.filter((item: any) =>
    item.nombre.toLowerCase().includes(producerSearch.toLowerCase())
  );

  useEffect(() => {
    const productoresIds = JSON.parse(decryptText(sessionStorage.getItem("prod") || "") || "[]");
    const filter = JSON.parse(decryptText(sessionStorage.getItem("filters") || "") || "{}");
    
    if (productoresIds.length > 0 && fatherProducerCodesArray.length > 0) {
      const firstProducer = fatherProducerCodesArray[0]; 
      if (filter.parentProducerId === null) {
      if (productoresIds.includes(firstProducer.id)) {
        setSelectedParentProducerId(firstProducer.id);
      }
    }
    }
  }, [fatherProducerCodesArray]);
  return (
    <div className="flex items-center rounded-[2px] bg-bg-filtros w-full">
      <div className="flex flex-wrap items-center min-h-[40px]">
        <div className="h-3/4 flex items-center py-1 px-3 border-gray-300">
          <Dropdown
            reset={reset}
            onInputChange={(value: string) => handleInputChange('parentProducerSearch', value)}
            onSelectChange={(value: any) => {
              setSelectedParentProducerId(value);
              onParentProducerChange(value);
              handleSelectChange(value, true);
            }}
            key={`${selectedSeasonId}-${reset}`} 
            name="nombre"
            description="Cód Padre-Productor"
            childrenOptions={fatherProducerCodesArray}
            relationOptions={[]}
            selectedValue={selectedParentProducerId || ""}
            searchValue={parentProducerSearch}
            fieldName={`parentProducer`}
          />
        </div>
        <div className="h-[80%] w-[1px] bg-gray-300"></div>
        <div className="h-3/4 flex items-center py-1 px-3 border-gray-300">
          <Dropdown
            reset={reset}
            onInputChange={(value: string) => handleInputChange('producerSearch', value)}
            onSelectChange={(value: any) => {
              setSelectedProducerId(value);
              onProducerChange(value);

              if (relations?.especies && relations.especies.length > 0) {
                const userSelectedSpecies = localStorage.getItem("userSelectedSpecies") === "true";
                const lastSelectedSpecies = localStorage.getItem("lastSelectedSpecies");

                if (userSelectedSpecies && lastSelectedSpecies) {
                  const lastSpeciesExists = relations.especies.some(
                    (especie: any) => especie.especieId === Number(lastSelectedSpecies)
                  );
                  
                  if (lastSpeciesExists) {
                    setSelectedSpeciesId(Number(lastSelectedSpecies));
                    onSpeciesChange(Number(lastSelectedSpecies));
                    return;
                  }
                }

                const cherries = relations.especies.find((especie: any) => especie.especieId === 3);
                const defaultSpecies = cherries || relations.especies.sort(
                  (a: Especie, b: Especie) => Number(a.especieId) - Number(b.especieId)
                )[0];

                if (defaultSpecies) {
                  setSelectedSpeciesId(defaultSpecies.especieId);
                  onSpeciesChange(defaultSpecies.especieId);
                }
              }
            }}
            name="nombre"
            description="Cód Hijo-Nombre"
            childrenOptions={filteredChildrenNameCodesArray}
            relationOptions={[]}
            selectedValue={selectedProducerId}
            searchValue={producerSearch}
            fieldName={`producer`}
          />
        </div>
        <div className="h-[80%] w-[1px] bg-gray-300"></div>
        <div className="h-3/4 flex items-center py-1 px-3 border-gray-300">
        <Dropdown
            reset={reset}
            onInputChange={(value: string) => handleInputChange('seasonSearch', value)}
            onSelectChange={(value: any) => {
              if (value !== selectedSeasonId) {
                setSelectedSeasonId(value);
                onSeasonChange(value);
                setSelectedVarietyId(null);
                onVarietyChange(null);

                if (relations?.especies && relations.especies.length > 0) {
                  const userSelectedSpecies = localStorage.getItem("userSelectedSpecies") === "true";
                  const lastSelectedSpecies = localStorage.getItem("lastSelectedSpecies");

                  if (userSelectedSpecies && lastSelectedSpecies) {
                    const lastSpeciesExists = relations.especies.some(
                      (especie: any) => especie.especieId === Number(lastSelectedSpecies)
                    );
                    
                    if (lastSpeciesExists) {
                      setSelectedSpeciesId(Number(lastSelectedSpecies));
                      onSpeciesChange(Number(lastSelectedSpecies));
                      return;
                    }
                  }

                  const cherries = relations.especies.find((especie: any) => especie.especieId === 3);
                  const defaultSpecies = cherries || relations.especies.sort(
                    (a: Especie, b: Especie) => Number(a.especieId) - Number(b.especieId)
                  )[0];

                  if (defaultSpecies) {
                    setSelectedSpeciesId(defaultSpecies.especieId);
                    onSpeciesChange(defaultSpecies.especieId);
                  }
                }
              }
              setReset(false);
            }}
            description="Temporada"
            name="nombre"
            childrenOptions={filteredSeasonArray}
            relationOptions={[]}
            selectedValue={selectedSeasonId}
            searchValue={seasonSearch}
            fieldName={`season`}
        />
        </div>
        <div className="h-[80%] w-[1px] bg-gray-300"></div>
        <div className="h-3/4 flex items-center py-1 px-3 border-gray-300">
          <Dropdown
            reset={reset}
            onInputChange={(value: string) => handleInputChange('speciesSearch', value)}
            onSelectChange={(value: any) => {
              if (value !== selectedSpeciesId) {
                setSelectedVarietyId(null);
                onVarietyChange(null);
                setUserSelectedSpecies(true);
                localStorage.setItem("userSelectedSpecies", "true");
                localStorage.setItem("lastSelectedSpecies", value.toString());
                sessionStorage.removeItem("autoSelectedSpecies");
                setSelectedSpeciesId(value);
                onSpeciesChange(value);
              }
              setReset(false);
            }}
            description="Especie"
            name="nombre"
            childrenOptions={filteredSpeciesArray}
            relationOptions={relations?.especies.map((especie: Especie) => Number(especie.especieId))}
            selectedValue={selectedSpeciesId}
            searchValue={speciesSearch}
            fieldName={`species`}
          />
        </div>
        <div className="h-[80%] w-[1px] bg-gray-300"></div>
        <div className="h-3/4 flex items-center py-1 px-3">
          <Dropdown
            reset={reset}
            onInputChange={(value: string) => handleInputChange('varietySearch', value)}
            onSelectChange={(value: any) => {
              setSelectedVarietyId(value);
              onVarietyChange(value);
              //handleSelectChangeRelation();
              setReset(false);
            }}
            description="Variedad"
            name="nombre"
            childrenOptions={filteredVarietiesArray}
            relationOptions={relations?.especies.length != 0 ? relations?.especies.find((e: any) => e.especieId === selectedSpeciesId)?.variedades : []}
            selectedValue={selectedVarietyId}
            searchValue={varietySearch}
            fieldName={`variety`}
          />
        </div>
        <div className="h-3/4 flex items-center py-2 px-3 mr-6">
          <button className="rounded-full w-[79px] h-[30px] bg-[#FFF0F0] text-[#E36464] btn-reset-filter underline" onClick={handleReset}>Limpiar Filtros</button>
        </div>
      </div>
    </div>
  );
};

export default Filtros;